module.exports = __webpack_public_path__ + "static/nm-ef4b4c58e4e8ee02fa3e4e547d4fdd80.png";